// removed by extract-text-webpack-plugin
module.exports = {"grid":"_1TGOhikKpPz4woHu7OxahR","gridColumn":"_1pTUst0vV05zktETt7-5nh","gridItem":"_3-r1qCQDDqv4VSJwGIT4ok"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/masonry/masonry.css
// module id = 925
// module chunks = 0